import {
  emailWithOutlookCallbackService,
  getPublishEmailSendService,
  getPublishService,
  sendEmailWithOutlookService,
  scheduleEmailService,
  saveEmailDataService,
  getRecipientCountService,
  getHTMLLinkService,
  getPromoCodesService,
  oldExportWidgetsService,
  getOldPromoCodesService,
} from "modules/Services/PublishService";
// import { exportWidgetsService } from "modules/Services/SalesXGroupsService";
import {
  EMAIL_BROWSER,
  PUBLISH,
  EMAIL_WITH_OUTLOOK,
  PUBLISH_SUBMIT,
  SCHEDULE_EMAIL,
  SAVE_PUBLISH_STATE,
  ALL_ARTICLES_IN_EDITION,
  PROMO_CODES,
} from "../../constants/actionTypes";
import store from "../../store/index";
import { IPromoCode, IPublishData } from "./interfaces";
import { getQueryEmailId } from "modules/EmailBrowser/utils";
import { serializePublishData, shareEmailOnLinkedIn, shareEmailOnTwitter } from "./utils";
import { resetCampaigns } from "modules/Campaigns/CampaignAssets/actions";
import { shareEmailOnSocialService } from "modules/Services/DesignService";
import { enablePublishButton } from "modules/Campaigns/Emails/actions";
import { resetAllData } from "modules/Campaigns/utils";
import { API_BASE_PUBLISH } from "constants/index";

/**
 * * Publish screen Actions
 */

export const openPublishSidebar = () => {
  store.dispatch({
    type: PUBLISH.OPEN,
  });
};

export const closePublishSidebar = () => {
  store.dispatch({
    type: PUBLISH.CLOSE,
  });
};

export const openUpgradePremiumBox = () => {
  store.dispatch({
    type: PUBLISH.SEND_CONFIRMATION_OPEN,
  });
};

export const closeSendConfirmationBox = () => {
  store.dispatch({
    type: PUBLISH.SEND_CONFIRMATION_CLOSE,
  });
};

export const sendPublishData = (values: FormData, isPremium: boolean, callback: any) => {
  store.dispatch({
    type: PUBLISH_SUBMIT.LOAD,
    isPremium: isPremium,
  });
  getPublishEmailSendService(values)
    .then((res) => {
      if (res.status === 200) {
        resetCampaigns();
        store.dispatch({
          type: PUBLISH_SUBMIT.SUCCESS,
          payload: values,
          isPremium: isPremium,
        });
        store.dispatch({
          type: EMAIL_BROWSER.REMOVE_EMAIL,
          payload: { emailId: values.get("version_id"), campaignId: values.get("asset_id") },
        });
        resetAllData();
      }
      callback(false);
    })
    .catch((err) => {
      console.log(err);
      callback(false);
      store.dispatch({
        type: PUBLISH.LOAD_FAIL,
        payload: [],
      });
    });
};

export const scheduleEmail = (data: FormData, isPremium: boolean, callback: any) => {
  store.dispatch({
    type: SCHEDULE_EMAIL.LOAD,
    isPremium: isPremium,
  });
  scheduleEmailService(data)
    .then((res) => {
      if (res.status === 200) {
        resetCampaigns();
        store.dispatch({
          type: SCHEDULE_EMAIL.SUCCESS,
          isPremium: isPremium,
        });
        store.dispatch({
          type: EMAIL_BROWSER.REMOVE_EMAIL,
          payload: { emailId: data.get("version_id"), campaignId: data.get("asset_id") },
        });
      }
      callback(false);
    })
    .catch((err) => {
      console.log(err);
      callback(false);
      store.dispatch({
        type: SCHEDULE_EMAIL.FAIL,
      });
    });
};

export const dispatchErrorInSaveState = () => {
  store.dispatch({
    type: SAVE_PUBLISH_STATE.FIELD_ERROR,
  });
};
export const saveEmailData = (data: FormData, isScheduled?: boolean, editionStatus?: string) => {
  store.dispatch({
    type: SAVE_PUBLISH_STATE.LOAD,
  });
  saveEmailDataService(data)
    .then((res) => {
      if (res?.data?.success) {
        if (editionStatus !== "Sent") {
          store.dispatch({
            type: ALL_ARTICLES_IN_EDITION.UPDATE_EMAIL_STATUS,
            payload: isScheduled ? "Scheduled" : "Draft",
          });
        }
        store.dispatch({
          type: SAVE_PUBLISH_STATE.SUCCESS,
          payload: {
            sender_name: data.get("sender_name"),
            subject: data.get("subject"),
            selected_sender: data.get("sender_email"),
            reply_to: data.get("reply_to_email"),
          },
        });
      }
    })
    .catch(() => {
      store.dispatch({ type: SAVE_PUBLISH_STATE.FAIL });
    });
};

export const getPublishData = (callback?: any, outlookRoute?: number) => {
  store.dispatch({
    type: PUBLISH.LOAD,
  });
  let versionId: number = getQueryEmailId();
  getPublishService(versionId, outlookRoute)
    .then((res) => {
      const serializedData: IPublishData = serializePublishData(res.data);
      store.dispatch({
        type: PUBLISH.LOAD_SUCCESS,
        payload: serializedData,
      });
      let disabledPublish = store.getState().design.disablePublish;
      if (disabledPublish) enablePublishButton();
      if (callback) callback(res.data.version_subject);
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: PUBLISH.LOAD_FAIL,
        payload: [],
      });
    });
};

export const updateStateOfPublishData = (subject?: string, senderName?: string) => {
  store.dispatch({
    type: SAVE_PUBLISH_STATE.UPDATE,
    payload: {
      sender_name: senderName,
      subject,
    },
  });
};

export const resetLoadedStateOfPublishData = () => {
  store.dispatch({ type: PUBLISH.RESET_LOADED });
};

export const resetShowingNotPremiumPopup = () => {
  store.dispatch({ type: PUBLISH.RESET_SHOW_NOT_PREMIUM });
};

export const sendEmailWithOutlook = (
  campaignId: string,
  emailId: string,
  outlook_route: string,
  is_custom: string
) => {
  store.dispatch({
    type: EMAIL_WITH_OUTLOOK.LOAD,
  });
  sendEmailWithOutlookService(campaignId, emailId, outlook_route, is_custom)
    .then((res: any) => {
      console.log("resp: ", res);
      sessionStorage.setItem("campaign_id", campaignId);
      sessionStorage.setItem("email_id", emailId);
      if (res.data.is_authorized) {
        if (sessionStorage.getItem("no_redirect")) {
          sessionStorage.removeItem("no_redirect");
        }
        store.dispatch({
          type: EMAIL_WITH_OUTLOOK.SUCCESS,
          payload: res.data,
        });
        store.dispatch({ type: PUBLISH.OUTLOOK_ROUTE_SUCCESS });
        store.dispatch({ type: EMAIL_WITH_OUTLOOK.SEND_FROM_DISABLE });
      } else {
        if (!sessionStorage.getItem("no_redirect")) {
          sessionStorage.removeItem("no_redirect");
          window.location.replace(res.data.url);
          // redirect to outlook connection page only if clicked
        } else {
          store.dispatch({
            type: EMAIL_WITH_OUTLOOK.FAIL,
          });
          resetOutlookConnection();
        }
      }
    })
    .catch((err) => {
      store.dispatch({
        type: EMAIL_WITH_OUTLOOK.FAIL,
      });
    });
};

export const emailWithOutlookCallback = (
  code: string,
  state: string,
  sessionState: string,
  campaignId: string | null,
  emailId: string | null,
  history: any
) => {
  emailWithOutlookCallbackService(code, state, sessionState).then((res) => {
    console.log("callback res: ", res);
    sessionStorage.setItem("callback_success", res.data.success);
    store.dispatch({
      type: EMAIL_WITH_OUTLOOK.SET_CALLBACK_STATE,
      payload: { callback_success_state: res.data.success.toString() },
    });
    if (history) {
      history.push(`/campaigns/editionedit/publish/?campaign_id=${campaignId}&email_id=${emailId}`);
      return;
    }
    window.location.replace(`/campaigns/editionedit/publish/?campaign_id=${campaignId}&email_id=${emailId}`);
  });
};

export const shareEmailOnSocial = (params?: any) => {
  let data = new FormData();
  data.append("email_id", params.emailId);

  getHTMLLink(data)
    .then((res) => {
      if (res.data.success === true) {
        if (params.platform === "LinkedIn") {
          shareEmailOnLinkedIn(`${API_BASE_PUBLISH}export_email_html_link/?email_id=${res.data.uuid_campaign_id}`);
        } else if (params.platform === "Twitter") {
          shareEmailOnTwitter(`${API_BASE_PUBLISH}export_email_html_link/?email_id=${res.data.uuid_campaign_id}`);
        }
      }
    })
    .catch((err) => {
      console.log("error in export to social ", err);
    });
};

export const getRecipientCount = (params?: any, callback?: any) => {
  getRecipientCountService(params)
    .then((res) => {
      if (res.data.success === true) {
        callback(res.data.total_recipients, res.data.mailable_recipients);
      }
    })
    .catch((err) => {
      console.log("error in export to social ", err);
    });
};

export const getHTMLLink = (params: any) => {
  return getHTMLLinkService(params);
};

export const resetOutlookConnection = () => {
  store.dispatch({ type: EMAIL_WITH_OUTLOOK.RESET });
};

export const getPromoCodes = (campaignId: string) => {
  store.dispatch({
    type: PROMO_CODES.LOAD,
  });
  getOldPromoCodesService(campaignId)
    .then((res) => {
      store.dispatch({
        type: PROMO_CODES.SUCCESS,
        promoCodes: res.data.success ? res.data.data.promotion_codes : [],
      });
    })
    .catch((err) => {
      store.dispatch({
        type: PROMO_CODES.FAIL,
      });
      console.log("error in get promo codes ", err);
    });
};

export const exportWidgets = (promoCodes: string[]) => {
  oldExportWidgetsService(promoCodes)
    .then((res) => {
      store.dispatch({
        type: PROMO_CODES.EXPORT_SUCCESS,
        promoCodesExportSuccess: res.data.success,
      });
    })
    .catch((err) => {
      console.log("error in export widgets ", err);
    });
};
